<template>
    <div class="page-item-info-other-lenses" v-if="otherLenses">
        <div class="page-item-info-other-lenses__anchor"
            id="page-item-info-other-lenses"
        />
        <div class="page-item-info-other-lenses__content">
            <div class="page-item-info-other-lenses__content-title">
                <a class="page-item-info-other-lenses__content-title-link"
                    v-bind:href="otherLenses.url"
                    v-text="title"
                />
            </div>
            <div class="page-item-info-other-lenses__content-description"
                v-text="description"
            />
            <a class="page-item-info-other-lenses__content-button"
                v-bind:href="otherLenses.url"
                >
                <ui-button
                    isUppercase
                    >
                    Смотреть
                </ui-button>
            </a>
        </div>
        <div class="page-item-info-other-lenses__images"
            v-if="images !== null"
            >
            <a class="page-item-info-other-lenses__images-item"
                v-for="(item, i) in images"
                v-bind:key="i"
                v-bind:style="{ backgroundImage: `url(${item})` }"
                v-bind:href="otherLenses.url"
            />
            <div class="page-item-info-other-lenses__images-item-empty"
                 v-if="images.length === 1"
            >
                <common-diagonal-placeholder />
            </div>
        </div>
    </div>
</template>

<script>
// import utils from '~/utils';

export default {
    name: 'page-item-info-other-lenses',
    props: {
        item: {
            type: Object,
        },
        otherLenses: {
            type: Object,
        },
        lensType: {
            type: String,
        },
    },
    computed: {
        title() {
            if (this.lensType === 'Оптика') {
                return this.item.title + ' В СОЛНЦЕ ↗\uFE0E';
            }
            return this.item.title + ' В ОПТИКЕ ↗\uFE0E';
        },
        description() {
            if (this.lensType === 'Оптика') {
                return 'Эта же оправа с солнцезащитными линзами';
            }
            return 'Эта же оправа с линзами для зрения';
        },
        images() {
            if (!this.otherLenses.images || this.otherLenses.images.length < 2) {
                return null;
            }
            return [ this.otherLenses.images[0], this.otherLenses.images[1] ];
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-item-info-other-lenses {
    position: relative;
    display: flex;
    align-items: stretch;
    justify-content: flex-start;
    width: 100%;
    &__anchor {
        display: block;
        position: absolute;
        top: -64px;
    }
    &__content {
        flex: 0 0 auto;
        width: 33.33%;
        padding: 16px;
        &-title {
            .typography-display-md();

            margin-bottom: 36px;

            text-transform: uppercase;
        }
        &-description {
            .typography-display-md();

            margin-bottom: 24px;
        }
        &-button {
            display: block;
            width: 140px;

            text-decoration: none;
        }
    }
    &__images {
        flex: 1 1 100%;
        display: flex;
        align-items: stretch;
        justify-content: flex-start;
        &-item {
            width: 50%;
            padding-top: 61.25%;
            border-left: 1px solid @color-gray-lightest;

            background-position: center;
            background-size: cover;
        }
        &-item-empty {
            width: 50%;
            border-left: 1px solid @color-gray-lightest;
        }
    }
    @media @media-lg-down {
        &__content {
            flex: 0 0 auto;
            width: 33.33%;
            padding: 16px;
            &-title {
                .typography-display-sm();

                margin-bottom: 28px;
            }
            &-description {
                .typography-display-sm();

                margin-bottom: 16px;
            }
        }
    }
    @media @media-md-down {
        flex-direction: column-reverse;
        &__anchor {
            top: -104px;
        }
        &__content {
            width: 100%;
            border-top: 1px solid @color-gray-lightest;
            &-description {
                max-width: 335px;
            }
        }
        &__images {
        }
    }
}
</style>
